export const selectLocationContent = state => state.helpAndAnswer.locationContent;
export const selectNavContent = state => state.helpAndAnswer.navContent;
